export default "__VITE_ASSET__Bp7SKMcy__"